import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery, withMutation } from '../../../hoc/withGraphql';
import getProviderEarnings from './getProviderEarnings.graphql';
import getTransactionLedger from './getTransactionLedger.graphql';
import getWalletInfo from './getWalletInfo.graphql';
import adjustWalletM from './adjustWallet.graphql';

const RED = '#D32F2F';
const TEAL = '#0E9488';
const INK = '#1F2733';

class Finance extends Component {
  constructor(props) {
    super(props);
    const y = new Date().getFullYear();
    this.state = { tab: 'earnings', busy: false, message: '', year: String(y), from: '', to: '', wQuery: '', wAmount: '', wReason: '' };
  }

  earnings = () => (this.props.earnings && this.props.earnings.getProviderEarnings) || null;
  ledger = () => (this.props.ledger && this.props.ledger.getTransactionLedger) || null;
  wallet = () => (this.props.wallet && this.props.wallet.getWalletInfo) || null;

  loadEarnings = () => this.props.earnings.refetch({ year: Number(this.state.year) || undefined });
  loadLedger = () => this.props.ledger.refetch({ fromDate: this.state.from || undefined, toDate: this.state.to || undefined });
  loadWallet = () => { if (this.state.wQuery) this.props.wallet.refetch({ query: this.state.wQuery }); };

  exportEarnings = () => {
    const e = this.earnings();
    if (!e || !e.results) return;
    const rows = [['Provider', 'Email', 'Completed jobs', 'Gross earnings', 'Currency']]
      .concat(e.results.map((r) => [r.name, r.email, r.completedJobs, r.grossEarnings, r.currency]));
    const csv = rows.map((r) => r.map((c) => `"${String(c == null ? '' : c).replace(/"/g, '""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = `besthand-1099-earnings-${e.year}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
  };

  adjust = async (sign) => {
    const w = this.wallet();
    if (!w || !w.userId) return;
    const amt = parseFloat(this.state.wAmount);
    if (!amt) { this.setState({ message: 'Enter an amount.' }); return; }
    const signed = sign * Math.abs(amt);
    if (!window.confirm(`${sign > 0 ? 'Credit' : 'Debit'} ${Math.abs(amt)} to ${w.name || w.email}'s wallet?`)) return;
    this.setState({ busy: true, message: '' });
    try {
      const res = await this.props.adjustMut({ variables: { userId: w.userId, amount: signed, reason: this.state.wReason || undefined } });
      const r = res && res.data && res.data.adjustWallet;
      if (r && r.status === 200) { this.setState({ busy: false, message: `✅ New balance: ${r.walletBalance}`, wAmount: '', wReason: '' }); this.loadWallet(); }
      else this.setState({ busy: false, message: (r && r.errorMessage) || 'Failed.' });
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  render() {
    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 8 });
    const tabBtn = (t) => ({ ...btn(this.state.tab === t ? RED : '#fff'), color: this.state.tab === t ? '#fff' : INK, border: this.state.tab === t ? 'none' : '1px solid #ddd' });
    const th = { padding: 10, textAlign: 'left' };
    const td = { padding: 10, borderTop: '1px solid #f0f0f0', fontSize: 13 };

    const e = this.earnings();
    const l = this.ledger();
    const w = this.wallet();

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">Finance</h1>
        <div style={{ marginBottom: 16 }}>
          <button style={tabBtn('earnings')} onClick={() => this.setState({ tab: 'earnings', message: '' })}>Provider earnings (1099)</button>
          <button style={tabBtn('ledger')} onClick={() => this.setState({ tab: 'ledger', message: '' })}>Ledger</button>
          <button style={tabBtn('wallet')} onClick={() => this.setState({ tab: 'wallet', message: '' })}>Wallet</button>
          {this.state.message ? <span style={{ marginLeft: 12, color: RED, fontWeight: 600 }}>{this.state.message}</span> : null}
        </div>

        {this.state.tab === 'earnings' && (
          <div>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 14 }}>
              <label style={{ fontSize: 13, color: '#666', marginRight: 6 }}>Year</label>
              <input style={{ ...input, width: 90 }} value={this.state.year} onChange={(ev) => this.setState({ year: ev.target.value.replace(/[^0-9]/g, '') })} />
              <button style={btn(RED)} onClick={this.loadEarnings}>Load</button>
              <button style={btn(TEAL)} onClick={this.exportEarnings}>Export 1099 CSV</button>
            </div>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead><tr style={{ background: '#fafafa' }}><th style={th}>Provider</th><th style={th}>Email</th><th style={th}>Completed jobs</th><th style={th}>Gross earnings</th></tr></thead>
                <tbody>
                  {(!e || !e.results || e.results.length === 0) && <tr><td style={td} colSpan={4}>No earnings for this year (click Load).</td></tr>}
                  {e && e.results && e.results.map((r) => (
                    <tr key={r.providerId}><td style={td}>{r.name}</td><td style={td}>{r.email}</td><td style={td}>{r.completedJobs}</td><td style={td}>{r.currency === 'USD' ? '$' : ''}{r.grossEarnings}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {this.state.tab === 'ledger' && (
          <div>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 14 }}>
              <input type="date" style={input} value={this.state.from} onChange={(ev) => this.setState({ from: ev.target.value })} />
              <input type="date" style={input} value={this.state.to} onChange={(ev) => this.setState({ to: ev.target.value })} />
              <button style={btn(RED)} onClick={this.loadLedger}>Load</button>
              {l && <span style={{ marginLeft: 8, fontSize: 13 }}>Charges <b style={{ color: '#2E7D32' }}>${l.totalCharges}</b> · Refunds <b style={{ color: '#C62828' }}>${l.totalRefunds}</b> · Net <b style={{ color: RED }}>${l.net}</b></span>}
            </div>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead><tr style={{ background: '#fafafa' }}><th style={th}>Date</th><th style={th}>Type</th><th style={th}>Amount</th><th style={th}>Booking</th><th style={th}>Reference</th></tr></thead>
                <tbody>
                  {(!l || !l.results || l.results.length === 0) && <tr><td style={td} colSpan={5}>No transactions (click Load).</td></tr>}
                  {l && l.results && l.results.map((x, i) => (
                    <tr key={i}><td style={td}>{x.date}</td><td style={td}><span style={{ color: x.type === 'refund' ? '#C62828' : '#2E7D32', fontWeight: 700 }}>{x.type}</span></td><td style={td}>{x.currency === 'USD' ? '$' : ''}{x.amount}</td><td style={td}>{x.bookingId ? `#${x.bookingId}` : '—'}</td><td style={{ ...td, fontSize: 11 }}>{x.reference || '—'}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {this.state.tab === 'wallet' && (
          <div>
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 14, marginBottom: 14 }}>
              <input style={{ ...input, width: 300 }} placeholder="User id or email" value={this.state.wQuery} onChange={(ev) => this.setState({ wQuery: ev.target.value })} onKeyDown={(ev) => ev.key === 'Enter' && this.loadWallet()} />
              <button style={btn(RED)} onClick={this.loadWallet}>Look up</button>
            </div>
            {w && w.status === 200 && (
              <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 14 }}>
                <div style={{ fontWeight: 800 }}>{w.name || w.email}</div>
                <div style={{ color: '#666', fontSize: 13 }}>{w.email}</div>
                <div style={{ fontSize: 26, fontWeight: 800, color: TEAL, margin: '8px 0' }}>${w.walletBalance}</div>
                <input style={{ ...input, width: 120 }} placeholder="Amount" value={this.state.wAmount} onChange={(ev) => this.setState({ wAmount: ev.target.value.replace(/[^0-9.]/g, '') })} />
                <input style={{ ...input, width: 240 }} placeholder="Reason (optional)" value={this.state.wReason} onChange={(ev) => this.setState({ wReason: ev.target.value })} />
                <button style={btn('#2E7D32')} disabled={this.state.busy} onClick={() => this.adjust(1)}>Credit</button>
                <button style={btn('#C62828')} disabled={this.state.busy} onClick={() => this.adjust(-1)}>Debit</button>
                <div style={{ marginTop: 14 }}>
                  <div style={{ fontWeight: 700, marginBottom: 6 }}>Recent wallet history</div>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead><tr style={{ background: '#fafafa' }}><th style={th}>Date</th><th style={th}>Amount</th><th style={th}>By</th></tr></thead>
                    <tbody>
                      {(w.history || []).length === 0 && <tr><td style={td} colSpan={3}>No history.</td></tr>}
                      {(w.history || []).map((h) => (
                        <tr key={h.id}><td style={td}>{h.createdAt ? h.createdAt.slice(0, 10) : '—'}</td><td style={td}>${h.amount}</td><td style={td}>{h.transactionId || h.paidBy || '—'}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {w && w.status !== 200 && this.state.wQuery && w.errorMessage && <div style={{ color: '#C62828' }}>{w.errorMessage}</div>}
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  withQuery(getProviderEarnings, { name: 'earnings', options: { variables: {}, fetchPolicy: 'network-only', ssr: false } }),
  withQuery(getTransactionLedger, { name: 'ledger', options: { variables: {}, fetchPolicy: 'network-only', ssr: false } }),
  withQuery(getWalletInfo, { name: 'wallet', options: { variables: { query: '' }, fetchPolicy: 'network-only', ssr: false } }),
  withMutation(adjustWalletM, { name: 'adjustMut' }),
)(Finance);
